import React, { useCallback, useMemo } from "react";
import { Image, View } from "react-native";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Button } from "../../../../atom/button/Button";
import { useAnswerForId } from "../../behaviours/useAnswers";
import { useAnswersValidation } from "../../behaviours/useAnswersValidation";
import { QuestionItemState, useQuestionItemState } from "../../behaviours/useQuestionItemState";
import { style as strikeOutButtonWithPrintQuestionItemStyle } from "./StrikeOutButtonWithPrintQuestionItem.style";
const StrikeOutButtonWithPrintQuestionItem = ({ domain, segment, question, questionParentId, }) => {
    const titleText = useI18nMessage({ domain, id: question.translationKey, values: { segment: segment.toLowerCase() } });
    const { answer, onChange } = useAnswerForId({ id: questionParentId });
    const selectedAnswer = answer && answer.find((id) => id === question.id);
    const { validateMaxAnswers } = useAnswersValidation();
    const state = useQuestionItemState({ questionParentId, question });
    const handleOnChange = useCallback(() => {
        onChange({ questionId: question.id, answer: selectedAnswer ? undefined : question.id });
        validateMaxAnswers();
    }, [onChange, question.id, selectedAnswer, validateMaxAnswers]);
    const checked = state === QuestionItemState.SELECTED;
    const style = useMemo(() => strikeOutButtonWithPrintQuestionItemStyle(), []);
    return (React.createElement(View, { style: style.container, testID: "strike-out-button-with-print-question-item" },
        React.createElement(Button, { checked: checked, style: { button: style.button, text: checked && style.buttonText }, testID: question.id, title: titleText, onPress: handleOnChange },
            React.createElement(View, null,
                React.createElement(Image, { resizeMode: "contain", style: style.print, source: {
                        uri: question.metadata.print,
                    } }),
                checked && React.createElement(View, { style: style.strikeOut })))));
};
export { StrikeOutButtonWithPrintQuestionItem };
